var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var fullFormValidator = function (data, formIndex, customErrors) {
    if (customErrors === void 0) { customErrors = {}; }
    return !Object.keys(formIndex).some(function (f) {
        var fieldData = (data && data[f]) || '';
        var formField = formIndex[f];
        if (formField.nestedFields) {
            return !nestedFormValidator(fieldData, formField.nestedFields);
        }
        var fieldCustomErrors = customErrors[f];
        if ((formField.required || fieldCustomErrors) &&
            formField.type !== 'checkbox') {
            if (!formField.multiple) {
                return isInvalidField(fieldData, formField.required, formField.validators, __assign(__assign({}, formField.customValidators), fieldCustomErrors), formField.name);
            }
            return isInvalidMultiField(fieldData, formField.required, formField.validators, __assign(__assign({}, formField.customValidators), fieldCustomErrors), formField.name);
        }
        return false;
    });
};
/** validate nested form fields recursively */
var nestedFormValidator = function (data, formArray) {
    return !formArray.some(function (f) {
        var fieldData = (data && data[f.name]) || '';
        if (f.nestedFields) {
            return !nestedFormValidator(fieldData, f.nestedFields);
        }
        if (f.required && f.type !== 'checkbox') {
            if (!f.multiple) {
                return isInvalidField(fieldData, f.required, f.validators, f.customValidators);
            }
            return isInvalidMultiField(fieldData, f.required, f.validators, f.customValidators);
        }
        return false;
    });
};
/** check empty value */
export var isEmpty = function (value) { return !value || String(value).length === 0; };
/** check empty array */
export var isEmptyArray = function (value) {
    return !value || !value.length > 0 || value[0] === '';
};
/** check email validity */
export var isValidEmail = function (email) {
    return email.includes('@') && !email.includes(' ');
};
/** check basic phone number validity */
// const phoneRegexp = new RegExp(/^\+/);
export var isValidPhoneNumber = function (phoneNumber) { return phoneNumber.startsWith('+'); };
export var isInvalidField = function (value, required, validators, customValidators, name) {
    var validations = { required: formValidators.required(value, required) };
    if (validators) {
        validators.forEach(function (v) {
            var selectedValidator = formValidators[v];
            if (selectedValidator) {
                validations[v] = selectedValidator(value);
            }
        });
    }
    if (customValidators) {
        Object.keys(customValidators).forEach(function (v) {
            var customValidator = customValidators[v];
            if (customValidator) {
                validations[v] = formValidators.custom(value, name, customValidator.validator);
            }
        });
    }
    return Object.values(validations).includes(true);
};
export var isInvalidMultiField = function (value, required, validators, customValidators, name) {
    var validations = {
        required: formValidators.requiredMulti(value, required),
    };
    if (validators) {
        validators.forEach(function (v) {
            var selectedValidator = formValidators[v];
            if (selectedValidator) {
                validations[v] = selectedValidator(value);
            }
        });
    }
    if (customValidators) {
        Object.keys(customValidators).forEach(function (v) {
            var customValidator = customValidators[v];
            if (customValidator) {
                validations[v] = formValidators.custom(value, name, customValidator.validator);
            }
        });
    }
    return Object.values(validations).includes(true);
};
/** construct an object with errors */
export var validationErrors = function (value, multiple, required, validators, customValidators, name) {
    var isMulti = !!multiple || false;
    var validations = {
        required: formValidators[isMulti ? 'requiredMulti' : 'required'](value, required),
    };
    if (validators) {
        validators.forEach(function (v) {
            var selectedValidator = formValidators[v];
            if (selectedValidator) {
                validations[v] = selectedValidator(value);
            }
        });
    }
    if (customValidators) {
        Object.keys(customValidators).forEach(function (v) {
            var customValidator = customValidators[v];
            if (customValidator) {
                validations[v] = formValidators.custom(value, name, customValidator.validator);
            }
        });
    }
    return validations;
};
/** select the appropriate validator */
var formValidators = {
    required: function (value, required) { return required && isEmpty(value); },
    requiredMulti: function (value, required) { return required && isEmptyArray(value); },
    email: function (value) { return !isEmpty(value) && !isValidEmail(value); },
    phone: function (value) { return !isEmpty(value) && !isValidPhoneNumber(value); },
    custom: function (value, name, validator) {
        return !isEmpty(value) && validator(value, name) === true;
    },
};
/** Produce formatted error messages */
export var formErrors = {
    required: function (label) {
        return (label && "".concat(label, " is a required field.")) || 'This field is required';
    },
    email: function (label) {
        return (label && "".concat(label, " is invalid.")) || 'This email address is invalid';
    },
    phone: function (label) {
        return (label &&
            "".concat(label, " should be prefixed by + \u200Cwith country code and then the local phone number.")) ||
            'This phone number should be prefixed by + ‌with country code and then the local phone number';
    },
    custom: function (label, message) {
        return (message && message.length > 0 && label
            ? "".concat(label, " ").concat(message)
            : "".concat(message)) || '';
    },
};
